import React, { useContext, useEffect, useState } from "react";
import {
  Box,
  Typography,
  Select,
  MenuItem,
  Button,
  Divider,
  useMediaQuery,
  useTheme,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress, // 👈 added for loaders
} from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import { OrderContext } from "../contexts/OrderContext";
import AccountCircleRoundedIcon from "@mui/icons-material/AccountCircleRounded";
import PeopleRoundedIcon from "@mui/icons-material/PeopleRounded";

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:8000";

const AdminDashboard = () => {
  const selectedManufacturer = JSON.parse(localStorage.getItem("selectedMfr"));
  const selectedDM = JSON.parse(localStorage.getItem("user"));
  const store_id = JSON.parse(localStorage.getItem("store_id"));
  const mfrId = selectedManufacturer?.id;

  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const filltersLink = [
    { linkName: "Antique Necklace", url: "" },
    { linkName: "Cosmic Collection", url: "" },
    { linkName: "Golden Bangles", url: "" },
    { linkName: "Royal Earrings", url: "" },
    { linkName: "Vintage Rings", url: "" },
  ];

  const [selectedFilter, setSelectedFilter] = useState(
    filltersLink[0].linkName,
  );
  const [activeStatsTab, setActiveStatsTab] = useState("day");

  const chartData = {
    // ... (keep existing chartData unchanged)
    "Antique Necklace": {
      day: [
        { name: "Mon", value: 25 },
        { name: "Tue", value: 40 },
        { name: "Wed", value: 18 },
        { name: "Thu", value: 32 },
        { name: "Fri", value: 20 },
        { name: "Sat", value: 45 },
        { name: "Sun", value: 30 },
      ],
      weekly: [
        { name: "Mon", value: 55 },
        { name: "Tue", value: 65 },
        { name: "Wed", value: 70 },
        { name: "Thu", value: 60 },
        { name: "Fri", value: 80 },
        { name: "Sat", value: 90 },
        { name: "Sun", value: 85 },
      ],
      monthly: [
        { name: "Mon", value: 100 },
        { name: "Tue", value: 120 },
        { name: "Wed", value: 130 },
        { name: "Thu", value: 125 },
        { name: "Fri", value: 150 },
        { name: "Sat", value: 140 },
        { name: "Sun", value: 135 },
      ],
      all: [
        { name: "Mon", value: 180 },
        { name: "Tue", value: 160 },
        { name: "Wed", value: 190 },
        { name: "Thu", value: 200 },
        { name: "Fri", value: 210 },
        { name: "Sat", value: 205 },
        { name: "Sun", value: 195 },
      ],
    },
    "Cosmic Collection": {
      day: [
        { name: "Mon", value: 35 },
        { name: "Tue", value: 28 },
        { name: "Wed", value: 45 },
        { name: "Thu", value: 22 },
        { name: "Fri", value: 38 },
        { name: "Sat", value: 30 },
        { name: "Sun", value: 27 },
      ],
      weekly: [
        { name: "Mon", value: 65 },
        { name: "Tue", value: 75 },
        { name: "Wed", value: 70 },
        { name: "Thu", value: 90 },
        { name: "Fri", value: 85 },
        { name: "Sat", value: 95 },
        { name: "Sun", value: 80 },
      ],
      monthly: [
        { name: "Mon", value: 120 },
        { name: "Tue", value: 130 },
        { name: "Wed", value: 125 },
        { name: "Thu", value: 140 },
        { name: "Fri", value: 150 },
        { name: "Sat", value: 145 },
        { name: "Sun", value: 135 },
      ],
      all: [
        { name: "Mon", value: 200 },
        { name: "Tue", value: 220 },
        { name: "Wed", value: 210 },
        { name: "Thu", value: 240 },
        { name: "Fri", value: 230 },
        { name: "Sat", value: 250 },
        { name: "Sun", value: 245 },
      ],
    },
    "Golden Bangles": {
      day: [
        { name: "Mon", value: 20 },
        { name: "Tue", value: 35 },
        { name: "Wed", value: 25 },
        { name: "Thu", value: 30 },
        { name: "Fri", value: 40 },
        { name: "Sat", value: 38 },
        { name: "Sun", value: 28 },
      ],
      weekly: [
        { name: "Mon", value: 55 },
        { name: "Tue", value: 60 },
        { name: "Wed", value: 70 },
        { name: "Thu", value: 68 },
        { name: "Fri", value: 75 },
        { name: "Sat", value: 85 },
        { name: "Sun", value: 90 },
      ],
      monthly: [
        { name: "Mon", value: 100 },
        { name: "Tue", value: 110 },
        { name: "Wed", value: 105 },
        { name: "Thu", value: 120 },
        { name: "Fri", value: 130 },
        { name: "Sat", value: 125 },
        { name: "Sun", value: 115 },
      ],
      all: [
        { name: "Mon", value: 180 },
        { name: "Tue", value: 160 },
        { name: "Wed", value: 190 },
        { name: "Thu", value: 210 },
        { name: "Fri", value: 220 },
        { name: "Sat", value: 200 },
        { name: "Sun", value: 195 },
      ],
    },
  };

  const [pendingOrders, setPendingOrders] = useState([]);
  const [activeLinksCount, setActiveLinksCount] = useState(0);
  const [pendingReqs, setPendingReqs] = useState([]);
  const [pendingNonExistingUsers, setPendingNonExistingUsers] = useState([]);
  const [pendingOrdersCount, setPendingOrdersCount] = useState(null);
  const [activeUsersCount, setActiveUsersCount] = useState(0);
  const [activeGroupsCount, setActiveGroupsCount] = useState(0);
  const [isLogoutPopup, setIsLogoutPopup] = useState(false);
  const [storeInfo, setStoreInfo] = useState(null);

  // 👇 Individual loading states
  const [loadingLinks, setLoadingLinks] = useState(true);
  const [loadingGroups, setLoadingGroups] = useState(true);
  const [loadingPendingReqs, setLoadingPendingReqs] = useState(true);
  const [loadingNonExistingUsers, setLoadingNonExistingUsers] = useState(true);
  const [loadingOrders, setLoadingOrders] = useState(true);
  const [loadingActiveUsers, setLoadingActiveUsers] = useState(true); // if used later

  const pendingNonExistingUsersCount = pendingNonExistingUsers.filter(
    (pendingNEUser) => !pendingNEUser.is_created,
  ).length;

  // Fetch store information on component mount
  useEffect(() => {
    const fetchStoreInfo = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/api/auth/storeInfo/${mfrId}`,
        );

        if (response.data?.statusCode === 200) {
          setStoreInfo(response.data?.data);
        }
      } catch (error) {
        console.error("Error fetching store info:", error);
        setStoreInfo(null);
      }
    };

    if (mfrId) {
      fetchStoreInfo();
    }
  }, [mfrId]);

  useEffect(() => {
    const fetchActiveLinksCount = async () => {
      setLoadingLinks(true);
      try {
        const url = `${API_BASE_URL}/api/auth/links/${mfrId}`;
        const { data } = await axios.get(url);
        if (data.statusCode === 200) setActiveLinksCount(data.totalLinks);
      } catch (error) {
        console.error("Error fetching links:", error);
        setActiveLinksCount(0);
      } finally {
        setLoadingLinks(false);
      }
    };

    const fetchPendingReqsCount = async () => {
      setLoadingPendingReqs(true);
      try {
        const url = `${API_BASE_URL}/api/auth/temp-user-auth/${mfrId}`;
        const { data } = await axios.get(url);
        if (data.statusCode === 200) setPendingReqs(data?.data?.records || []);
      } catch (error) {
        console.error("Error fetching pending requests:", error);
        setPendingReqs([]);
      } finally {
        setLoadingPendingReqs(false);
      }
    };

    const fetchNonExistingUsers = async () => {
      setLoadingNonExistingUsers(true);
      try {
        const url = `${API_BASE_URL}/api/auth/non-existing-users/${store_id}/${mfrId}`;
        const { data } = await axios.get(url);
        if (data.statusCode === 200 && data?.data?.users) {
          setPendingNonExistingUsers(data.data.users);
        }
      } catch (error) {
        console.error("Error fetching non-existing users:", error);
        setPendingNonExistingUsers([]);
      } finally {
        setLoadingNonExistingUsers(false);
      }
    };

    const fetchPendingOrdersCount = async () => {
      setLoadingOrders(true);
      try {
        const response = await axios.get(
          `${API_BASE_URL}/api/fetchorder/getOrders`,
        );
        const orders = response.data?.data?.records || [];
        const ordersCount = response.data?.data?.totalRecords || 0;
        const ordersWithNewStatus =
          orders.filter((order) => order.status === "New") || [];
        setPendingOrders(ordersWithNewStatus);
        setPendingOrdersCount(ordersCount);
      } catch (error) {
        console.error("Error fetching orders:", error);
        setPendingOrders([]);
        setPendingOrdersCount(0);
      } finally {
        setLoadingOrders(false);
      }
    };

    const fetchActiveUsersCount = async () => {
      setLoadingActiveUsers(true);
      try {
        const res = await axios.get(
          `${API_BASE_URL}/api/auth/session/active-users`,
        );
        setActiveUsersCount(res.data?.total_active_users || 0);
      } catch (error) {
        console.error("Error fetching active users:", error);
        setActiveUsersCount(0);
      } finally {
        setLoadingActiveUsers(false);
      }
    };

    const fetchActiveGroupsCount = async () => {
      setLoadingGroups(true);
      try {
        const res = await axios.get(
          `${API_BASE_URL}/api/auth/user-groups/${mfrId}`,
        );
        setActiveGroupsCount(res.data.count || 0);
      } catch (error) {
        console.error("Error fetching groups:", error);
        setActiveGroupsCount(0);
      } finally {
        setLoadingGroups(false);
      }
    };

    const fetchAllCounts = async () => {
      await Promise.allSettled([
        fetchActiveLinksCount(),
        fetchPendingReqsCount(),
        fetchNonExistingUsers(),
        fetchPendingOrdersCount(),
        fetchActiveUsersCount(),
        fetchActiveGroupsCount(),
      ]);
    };

    fetchAllCounts();
  }, [mfrId, store_id]);

  const handleLogout = () => {
    localStorage.clear();
    const prefix = localStorage.getItem("urlPrefix");
    if (prefix) {
      navigate(`/${prefix}`);
    } else {
      navigate("/login");
    }
  };

  // Helper to render count or loader
  const renderCount = (loading, count) => {
    if (loading)
      return <CircularProgress size={24} sx={{ color: "#42A996" }} />;
    return count;
  };

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "#394A5C", px: isMobile ? 1 : 8 }}>
      <Box sx={{ p: isMobile ? 1 : 5 }}>
        {/* Dashboard Heading & Log Out Button */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            mb: 2,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: isMobile ? 0.5 : 1,
            }}
          >
            <AccountCircleIcon
              sx={{ fontSize: isMobile ? 28 : 36, fill: "#42A996" }}
            />

            <Typography
              sx={{
                color: "#9ca4ad",
                fontSize: isMobile ? 18 : 28,
                fontWeight: 700,
              }}
            >
              Hey{" "}
              <span style={{ fontStyle: "italic" }}>
                {selectedDM.name ?? "--"}
              </span>
            </Typography>
          </Box>

          <Box
            onClick={() => setIsLogoutPopup(true)}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              cursor: "pointer",
              px: isMobile ? 0.5 : 2,
              py: isMobile ? 0.5 : 1,
              borderRadius: 2,
              bgcolor: "#1E2F40",
              transition: "0.3s",
              ":hover": { bgcolor: "#273b4e" },
            }}
          >
            {!isMobile && (
              <Typography sx={{ color: "#fff", fontWeight: 500 }}>
                Logout
              </Typography>
            )}
            <LogoutRoundedIcon sx={{ color: "#fff" }} />
          </Box>
        </Box>

        {/* Content */}
        <Box
          sx={{
            bgcolor: isMobile ? "transparent" : "#42566bff",
            p: isMobile ? 1 : 4,
            borderRadius: 6,
            boxShadow: 20,
          }}
        >
          {/* Top Cards */}
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: isMobile ? "1fr 1fr" : "repeat(6, 1fr)",
              gap: isMobile ? 1.5 : 2,
              mb: 3,
            }}
          >
            {[
              {
                tab: "Active Links",
                count: activeLinksCount,
                loading: loadingLinks,
                url: "/show-active-links",
              },
              {
                tab: "User Groups",
                count: activeGroupsCount,
                loading: loadingGroups,
                url: "/users-group",
              },
              {
                tab: "Pending Requests",
                count: pendingReqs.length,
                loading: loadingPendingReqs,
                url: "/pending-requests",
              },
              {
                tab: "New User Requests",
                count: pendingNonExistingUsersCount,
                loading: loadingNonExistingUsers,
                url: "/new-user-requests",
              },
              {
                tab: "Orders",
                count: pendingOrdersCount || 0,
                loading: loadingOrders,
                url: "/order-summary",
              },
              {
                tab: "All Users",
                // count not shown, just icon
                url: "/all-users",
              },
            ].map((item, index) => (
              <Box
                key={index}
                onClick={() => navigate(item.url)}
                sx={{
                  bgcolor: "#1E2F40",
                  borderRadius: 3,
                  py: isMobile ? 2 : 3,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: "pointer",
                  boxShadow: "0px 4px 10px rgba(0,0,0,0.25)",
                  transition: "0.25s",
                  ":hover": {
                    transform: "translateY(-4px)",
                    bgcolor: "#42A996",
                  },
                }}
              >
                <Typography
                  sx={{
                    fontWeight: 700,
                    fontSize: isMobile ? 18 : 24,
                    color: "#fff",
                  }}
                >
                  {item.tab !== "All Users" ? (
                    renderCount(item.loading, item.count)
                  ) : (
                    <PeopleRoundedIcon />
                  )}
                </Typography>
                <Typography
                  sx={{
                    textAlign: "center",
                    fontSize: isMobile ? 12 : 15,
                    color: "#BFCBD7",
                  }}
                >
                  {item.tab}
                </Typography>
              </Box>
            ))}
          </Box>

          {/* Main Content */}
          <Box
            sx={{
              display: "flex",
              gap: 3,
              flexDirection: isMobile ? "column" : "row",
            }}
          >
            {/* Left Panel */}
            <Box
              sx={{
                width: isMobile ? "100%" : "48%",
                display: "flex",
                flexDirection: "column",
                gap: 3,
              }}
            >
              {/* Pending Orders */}
              <Box
                sx={{
                  bgcolor: "#1E2F40",
                  p: 3,
                  borderRadius: 3,
                  boxShadow: "0px 3px 10px rgba(0,0,0,0.25)",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    color: "#fff",
                  }}
                >
                  <Typography sx={{ fontWeight: 600 }}>
                    Pending Orders
                  </Typography>
                  <Typography
                    onClick={() => navigate("/order-summary")}
                    sx={{
                      fontSize: 14,
                      color: "#EF7849",
                      cursor: "pointer",
                      textDecoration: "underline",
                    }}
                  >
                    View more
                  </Typography>
                </Box>

                <Box
                  sx={{
                    mt: 3,
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                  }}
                >
                  {loadingOrders ? (
                    <Box
                      sx={{ display: "flex", justifyContent: "center", py: 2 }}
                    >
                      <CircularProgress size={30} sx={{ color: "#42A996" }} />
                    </Box>
                  ) : pendingOrders.length === 0 ? (
                    <Typography
                      sx={{
                        textAlign: "center",
                        color: "#FFF",
                        fontStyle: "italic",
                      }}
                    >
                      No new orders
                    </Typography>
                  ) : (
                    pendingOrders.slice(0, 4).map((order, index) => (
                      <React.Fragment key={index}>
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          <AccountCircleIcon sx={{ color: "#7593a9" }} />
                          <Typography
                            sx={{
                              color: "#C9D4DD",
                              fontSize: isMobile ? 12 : 16,
                            }}
                          >
                            <span style={{ fontWeight: 600 }}>
                              {order?.customerName}
                            </span>{" "}
                            has ordered{" "}
                            <span style={{ fontWeight: 600 }}>
                              {Array.isArray(order?.selectedTags)
                                ? order?.selectedTags.length
                                : 1}
                            </span>{" "}
                            item{Array.isArray(order?.selectedTags) ? "s" : ""}{" "}
                            (Tag No:{" "}
                            <span style={{ fontWeight: 600 }}>
                              {Array.isArray(order?.selectedTags)
                                ? order.selectedTags.join(", ")
                                : order?.selectedTags}
                            </span>
                            )
                          </Typography>
                        </Box>

                        {index !== pendingOrders.length - 1 && (
                          <Divider sx={{ bgcolor: "#FFF" }} />
                        )}
                      </React.Fragment>
                    ))
                  )}
                </Box>
              </Box>

              {/* Access Requests */}
              <Box
                sx={{
                  bgcolor: "#1E2F40",
                  p: 3,
                  borderRadius: 3,
                  boxShadow: "0px 3px 10px rgba(0,0,0,0.25)",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    color: "#fff",
                  }}
                >
                  <Typography sx={{ fontWeight: 600 }}>
                    Access Requests
                  </Typography>
                  <Typography
                    onClick={() => navigate("/pending-requests")}
                    sx={{
                      fontSize: 14,
                      color: "#EF7849",
                      textDecoration: "underline",
                      cursor: "pointer",
                    }}
                  >
                    View more
                  </Typography>
                </Box>

                <Box
                  sx={{
                    mt: 3,
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                  }}
                >
                  {loadingPendingReqs ? (
                    <Box
                      sx={{ display: "flex", justifyContent: "center", py: 2 }}
                    >
                      <CircularProgress size={30} sx={{ color: "#42A996" }} />
                    </Box>
                  ) : pendingReqs?.length === 0 ? (
                    <Typography
                      sx={{
                        textAlign: "center",
                        color: "#FFF",
                        fontStyle: "italic",
                      }}
                    >
                      No requests
                    </Typography>
                  ) : (
                    pendingReqs?.slice(0, 3).map((el, index) => (
                      <React.Fragment key={index}>
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          <AccountCircleIcon sx={{ color: "#7593a9" }} />
                          <Typography
                            sx={{
                              color: "#C9D4DD",
                              fontSize: isMobile ? 12 : 14,
                            }}
                          >
                            {el.user_name} is requesting access for{" "}
                            <strong>#{el.link_name}</strong>
                          </Typography>
                        </Box>

                        {index !== pendingReqs.length - 1 && (
                          <Divider sx={{ bgcolor: "#FFF" }} />
                        )}
                      </React.Fragment>
                    ))
                  )}
                </Box>
              </Box>
            </Box>

            {/* Right Panel (Chart) - unchanged */}
            <Box
              sx={{
                width: isMobile ? "100%" : "48%",
                bgcolor: "#1E2F40",
                p: 3,
                flex: 1,
                borderRadius: 3,
                boxShadow: "0px 3px 10px rgba(0,0,0,0.25)",
              }}
            >
              <Typography
                sx={{
                  fontSize: isMobile ? 17 : 20,
                  fontWeight: 700,
                  color: "white",
                  mb: 2,
                }}
              >
                Sales Overview
              </Typography>

              <Select
                fullWidth
                size="small"
                value={selectedFilter}
                onChange={(e) => setSelectedFilter(e.target.value)}
                sx={{
                  bgcolor: "#fff",
                  borderRadius: 1,
                  height: 40,
                  mb: 2,
                }}
              >
                {filltersLink.map((item, index) => (
                  <MenuItem key={index} value={item.linkName}>
                    {item.linkName}
                  </MenuItem>
                ))}
              </Select>

              <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", mb: 2 }}>
                {["day", "weekly", "monthly", "all"].map((tab) => (
                  <Button
                    key={tab}
                    onClick={() => setActiveStatsTab(tab)}
                    sx={{
                      bgcolor: activeStatsTab === tab ? "#42A996" : "#fff",
                      color: activeStatsTab === tab ? "#fff" : "#000",
                      fontSize: 12,
                      fontWeight: 600,
                      borderRadius: "20px",
                      px: 3,
                    }}
                  >
                    {tab.charAt(0).toUpperCase() + tab.slice(1)}
                  </Button>
                ))}
              </Box>

              <Box sx={{ height: 260 }}>
                <ResponsiveContainer width="100%" height="100%">
                  <BarChart
                    data={chartData[selectedFilter]?.[activeStatsTab] || []}
                    margin={{ top: 10, right: 20, left: -10, bottom: 10 }}
                  >
                    <CartesianGrid strokeDasharray="3 3" stroke="#2E3E50" />
                    <XAxis dataKey="name" stroke="#BDBDBD" />
                    <YAxis stroke="#BDBDBD" />
                    <Tooltip
                      cursor={{ fill: "transparent" }}
                      contentStyle={{
                        backgroundColor: "rgba(30,47,64,0.95)",
                        border: "1px solid #EF7849",
                        borderRadius: 6,
                        color: "#fff",
                      }}
                      labelStyle={{ color: "#EF7849" }}
                    />
                    <Bar
                      dataKey="value"
                      fill="#42A996"
                      barSize={25}
                      radius={[8, 8, 0, 0]}
                    />
                  </BarChart>
                </ResponsiveContainer>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>

      {/* Logout Popup - unchanged */}
      <Dialog
        open={isLogoutPopup}
        onClick={() => setIsLogoutPopup(false)}
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle>Logout</DialogTitle>
        <DialogContent>
          <Typography>Are you sure you want to logout?</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsLogoutPopup(false)} variant="outlined">
            Cancel
          </Button>
          <Button onClick={handleLogout} variant="contained" color="error">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default AdminDashboard;
